import React, { useState } from "react";
import {
  Button,
  Icon,
  Modal,
  Header,
  List,
  Container
} from "semantic-ui-react";
import styles from "../Sheds.module.css";

const ShedActionButtons = ({
  archiveButtonTitle,
  archiveButtonIcon,
  onArchiveButtonClick,
  withModal,
  selectedProducts,
  setOpenMessages
}) => {
  const [isArchiveConfirmShown, setArchiveConfirmShown] = useState(false);
  const isListOfProducts = Array.isArray(selectedProducts);
  const productCheck = withModal
    ? isListOfProducts
      ? selectedProducts.some(item => item.buckets.length > 0)
      : !!selectedProducts.buckets.length
    : false;

  return (
    <>
      <Modal
        onClose={() => setArchiveConfirmShown(false)}
        open={isArchiveConfirmShown}
        size="mini"
      >
        <Modal.Content>
          <Header size="big" className="bold">
            Archive the{" "}
            {isListOfProducts
              ? "following sheds"
              : `${selectedProducts.name} shed`}
            ?
          </Header>
          {isListOfProducts && (
            <List as="ol">
              {selectedProducts.map(product => (
                <List.Item as="li">{product.name}</List.Item>
              ))}
            </List>
          )}
          <Container textAlign="right">
            <Button
              color="green"
              content="Cancel"
              basic
              className={styles.cancelButton}
              onClick={() => setArchiveConfirmShown(false)}
            />
            <Button
              content="Archive"
              className={styles.addButton}
              onClick={onArchiveButtonClick}
              positive
            />
          </Container>
        </Modal.Content>
      </Modal>

      <Button
        basic
        size="small"
        className={styles.actionButton}
        onClick={() =>
          productCheck
            ? setOpenMessages(true)
            : withModal
            ? setArchiveConfirmShown(true)
            : onArchiveButtonClick()
        }
        color="green"
      >
        <Icon name={archiveButtonIcon} />
        {archiveButtonTitle}
      </Button>
    </>
  );
};

export default ShedActionButtons;
